/* @generated */
// prettier-ignore  
export const languageAlias = {
	"aa-saaho": "ssy",
	"aam": "aas",
	"aar": "aa",
	"abk": "ab",
	"adp": "dz",
	"afr": "af",
	"agp": "apf",
	"ais": "ami",
	"ajp": "apc",
	"ajt": "aeb",
	"aju": "jrb",
	"aka": "ak",
	"alb": "sq",
	"als": "sq",
	"amh": "am",
	"ara": "ar",
	"arb": "ar",
	"arg": "an",
	"arm": "hy",
	"art-lojban": "jbo",
	"asd": "snz",
	"asm": "as",
	"aue": "ktz",
	"ava": "av",
	"ave": "ae",
	"aym": "ay",
	"ayr": "ay",
	"ayx": "nun",
	"aze": "az",
	"azj": "az",
	"bak": "ba",
	"bam": "bm",
	"baq": "eu",
	"baz": "nvo",
	"bcc": "bal",
	"bcl": "bik",
	"bel": "be",
	"ben": "bn",
	"bgm": "bcg",
	"bh": "bho",
	"bhk": "fbl",
	"bic": "bir",
	"bih": "bho",
	"bis": "bi",
	"bjd": "drl",
	"bjq": "bzc",
	"bkb": "ebk",
	"blg": "iba",
	"bod": "bo",
	"bos": "bs",
	"bre": "br",
	"btb": "beb",
	"bul": "bg",
	"bur": "my",
	"bxk": "luy",
	"bxr": "bua",
	"cat": "ca",
	"ccq": "rki",
	"cel-gaulish": "xtg",
	"ces": "cs",
	"cha": "ch",
	"che": "ce",
	"chi": "zh",
	"chu": "cu",
	"chv": "cv",
	"cjr": "mom",
	"cka": "cmr",
	"cld": "syr",
	"cls": "sa",
	"cmk": "xch",
	"cmn": "zh",
	"cnr": "sr-ME",
	"cor": "kw",
	"cos": "co",
	"coy": "pij",
	"cqu": "quh",
	"cre": "cr",
	"cwd": "cr",
	"cym": "cy",
	"cze": "cs",
	"daf": "dnj",
	"dan": "da",
	"dap": "njz",
	"dek": "sqm",
	"deu": "de",
	"dgo": "doi",
	"dhd": "mwr",
	"dik": "din",
	"diq": "zza",
	"dit": "dif",
	"div": "dv",
	"djl": "dze",
	"dkl": "aqd",
	"drh": "mn",
	"drr": "kzk",
	"drw": "fa-AF",
	"dud": "uth",
	"duj": "dwu",
	"dut": "nl",
	"dwl": "dbt",
	"dzo": "dz",
	"ekk": "et",
	"ell": "el",
	"elp": "amq",
	"emk": "man",
	"en-GB-oed": "en-GB-oxendict",
	"eng": "en",
	"epo": "eo",
	"esk": "ik",
	"est": "et",
	"eus": "eu",
	"ewe": "ee",
	"fao": "fo",
	"fas": "fa",
	"fat": "ak",
	"fij": "fj",
	"fin": "fi",
	"fra": "fr",
	"fre": "fr",
	"fry": "fy",
	"fuc": "ff",
	"ful": "ff",
	"gav": "dev",
	"gaz": "om",
	"gbc": "wny",
	"gbo": "grb",
	"geo": "ka",
	"ger": "de",
	"gfx": "vaj",
	"ggn": "gvr",
	"ggo": "esg",
	"ggr": "gtu",
	"gio": "aou",
	"gla": "gd",
	"gle": "ga",
	"glg": "gl",
	"gli": "kzk",
	"glv": "gv",
	"gno": "gon",
	"gom": "kok",
	"gre": "el",
	"grn": "gn",
	"gti": "nyc",
	"gug": "gn",
	"guj": "gu",
	"guv": "duz",
	"gya": "gba",
	"hat": "ht",
	"hau": "ha",
	"hbs": "sr-Latn",
	"hdn": "hai",
	"hea": "hmn",
	"heb": "he",
	"her": "hz",
	"him": "srx",
	"hin": "hi",
	"hmo": "ho",
	"hrr": "jal",
	"hrv": "hr",
	"hun": "hu",
	"hy-arevmda": "hyw",
	"hye": "hy",
	"i-ami": "ami",
	"i-bnn": "bnn",
	"i-default": "en-x-i-default",
	"i-enochian": "und-x-i-enochian",
	"i-hak": "hak",
	"i-klingon": "tlh",
	"i-lux": "lb",
	"i-mingo": "see-x-i-mingo",
	"i-navajo": "nv",
	"i-pwn": "pwn",
	"i-tao": "tao",
	"i-tay": "tay",
	"i-tsu": "tsu",
	"ibi": "opa",
	"ibo": "ig",
	"ice": "is",
	"ido": "io",
	"iii": "ii",
	"ike": "iu",
	"iku": "iu",
	"ile": "ie",
	"ill": "ilm",
	"ilw": "gal",
	"in": "id",
	"ina": "ia",
	"ind": "id",
	"ipk": "ik",
	"isl": "is",
	"ita": "it",
	"iw": "he",
	"izi": "eza",
	"jar": "jgk",
	"jav": "jv",
	"jeg": "oyb",
	"ji": "yi",
	"jpn": "ja",
	"jw": "jv",
	"kal": "kl",
	"kan": "kn",
	"kas": "ks",
	"kat": "ka",
	"kau": "kr",
	"kaz": "kk",
	"kdv": "zkd",
	"kgc": "tdf",
	"kgd": "ncq",
	"kgh": "kml",
	"kgm": "plu",
	"khk": "mn",
	"khm": "km",
	"kik": "ki",
	"kin": "rw",
	"kir": "ky",
	"kmr": "ku",
	"knc": "kr",
	"kng": "kg",
	"koj": "kwv",
	"kom": "kv",
	"kon": "kg",
	"kor": "ko",
	"kpp": "jkm",
	"kpv": "kv",
	"krm": "bmf",
	"ktr": "dtp",
	"kua": "kj",
	"kur": "ku",
	"kvs": "gdj",
	"kwq": "yam",
	"kxe": "tvd",
	"kxl": "kru",
	"kzh": "dgl",
	"kzj": "dtp",
	"kzt": "dtp",
	"lak": "ksp",
	"lao": "lo",
	"lat": "la",
	"lav": "lv",
	"lbk": "bnc",
	"leg": "enl",
	"lii": "raq",
	"lim": "li",
	"lin": "ln",
	"lit": "lt",
	"llo": "ngt",
	"lmm": "rmx",
	"ltz": "lb",
	"lub": "lu",
	"lug": "lg",
	"lvs": "lv",
	"mac": "mk",
	"mah": "mh",
	"mal": "ml",
	"mao": "mi",
	"mar": "mr",
	"may": "ms",
	"meg": "cir",
	"mgx": "jbk",
	"mhr": "chm",
	"mkd": "mk",
	"mlg": "mg",
	"mlt": "mt",
	"mnt": "wnn",
	"mo": "ro",
	"mof": "xnt",
	"mol": "ro",
	"mon": "mn",
	"mri": "mi",
	"msa": "ms",
	"mst": "mry",
	"mup": "raj",
	"mwd": "dmw",
	"mwj": "vaj",
	"mya": "my",
	"myd": "aog",
	"myt": "mry",
	"nad": "xny",
	"nau": "na",
	"nav": "nv",
	"nbf": "nru",
	"nbl": "nr",
	"nbx": "gll",
	"ncp": "kdz",
	"nde": "nd",
	"ndo": "ng",
	"nep": "ne",
	"nld": "nl",
	"nln": "azd",
	"nlr": "nrk",
	"nno": "nn",
	"nns": "nbr",
	"nnx": "ngv",
	"no-bok": "nb",
	"no-bokmal": "nb",
	"no-nyn": "nn",
	"no-nynorsk": "nn",
	"nob": "nb",
	"nom": "cbr",
	"noo": "dtd",
	"nor": "no",
	"npi": "ne",
	"nte": "eko",
	"nts": "pij",
	"nxu": "bpp",
	"nya": "ny",
	"oci": "oc",
	"ojg": "oj",
	"oji": "oj",
	"ori": "or",
	"orm": "om",
	"ory": "or",
	"oss": "os",
	"oun": "vaj",
	"pan": "pa",
	"pat": "kxr",
	"pbu": "ps",
	"pcr": "adx",
	"per": "fa",
	"pes": "fa",
	"pli": "pi",
	"plt": "mg",
	"pmc": "huw",
	"pmk": "crr",
	"pmu": "phr",
	"pnb": "lah",
	"pol": "pl",
	"por": "pt",
	"ppa": "bfy",
	"ppr": "lcq",
	"prp": "gu",
	"prs": "fa-AF",
	"pry": "prt",
	"pus": "ps",
	"puz": "pub",
	"que": "qu",
	"quz": "qu",
	"rmr": "emx",
	"rmy": "rom",
	"roh": "rm",
	"ron": "ro",
	"rum": "ro",
	"run": "rn",
	"rus": "ru",
	"sag": "sg",
	"san": "sa",
	"sap": "aqt",
	"sca": "hle",
	"scc": "sr",
	"scr": "hr",
	"sgl": "isk",
	"sgn-BE-FR": "sfb",
	"sgn-BE-NL": "vgt",
	"sgn-BR": "bzs",
	"sgn-CH-DE": "sgg",
	"sgn-CO": "csn",
	"sgn-DE": "gsg",
	"sgn-DK": "dsl",
	"sgn-ES": "ssp",
	"sgn-FR": "fsl",
	"sgn-GB": "bfi",
	"sgn-GR": "gss",
	"sgn-IE": "isg",
	"sgn-IT": "ise",
	"sgn-JP": "jsl",
	"sgn-MX": "mfs",
	"sgn-NI": "ncs",
	"sgn-NL": "dse",
	"sgn-NO": "nsi",
	"sgn-PT": "psr",
	"sgn-SE": "swl",
	"sgn-US": "ase",
	"sgn-ZA": "sfs",
	"sh": "sr-Latn",
	"sin": "si",
	"skk": "oyb",
	"slk": "sk",
	"slo": "sk",
	"slv": "sl",
	"smd": "kmb",
	"sme": "se",
	"smo": "sm",
	"sna": "sn",
	"snb": "iba",
	"snd": "sd",
	"som": "so",
	"sot": "st",
	"spa": "es",
	"spy": "kln",
	"sqi": "sq",
	"src": "sc",
	"srd": "sc",
	"srp": "sr",
	"ssw": "ss",
	"sul": "sgd",
	"sum": "ulw",
	"sun": "su",
	"swa": "sw",
	"swc": "sw-CD",
	"swe": "sv",
	"swh": "sw",
	"szd": "umi",
	"tah": "ty",
	"tam": "ta",
	"tat": "tt",
	"tdu": "dtp",
	"tel": "te",
	"tgg": "bjp",
	"tgk": "tg",
	"tgl": "fil",
	"tha": "th",
	"thc": "tpo",
	"thw": "ola",
	"thx": "oyb",
	"tib": "bo",
	"tid": "itd",
	"tie": "ras",
	"tir": "ti",
	"tkk": "twm",
	"tl": "fil",
	"tlw": "weo",
	"tmk": "tdg",
	"tmp": "tyj",
	"tne": "kak",
	"tnf": "fa-AF",
	"ton": "to",
	"tpw": "tpn",
	"tsf": "taj",
	"tsn": "tn",
	"tso": "ts",
	"ttq": "tmh",
	"tuk": "tk",
	"tur": "tr",
	"tw": "ak",
	"twi": "ak",
	"uig": "ug",
	"ukr": "uk",
	"umu": "del",
	"und-aaland": "und-AX",
	"und-arevela": "und",
	"und-arevmda": "und",
	"und-bokmal": "und",
	"und-hakka": "und",
	"und-hepburn-heploc": "und-alalc97",
	"und-lojban": "und",
	"und-nynorsk": "und",
	"und-saaho": "und",
	"und-xiang": "und",
	"unp": "wro",
	"uok": "ema",
	"urd": "ur",
	"uzb": "uz",
	"uzn": "uz",
	"ven": "ve",
	"vie": "vi",
	"vol": "vo",
	"wel": "cy",
	"wgw": "wgb",
	"wit": "nol",
	"wiw": "nwo",
	"wln": "wa",
	"wol": "wo",
	"xba": "cax",
	"xho": "xh",
	"xia": "acn",
	"xkh": "waw",
	"xpe": "kpe",
	"xrq": "dmw",
	"xsj": "suj",
	"xsl": "den",
	"xss": "zko",
	"ybd": "rki",
	"ydd": "yi",
	"yen": "ynq",
	"yid": "yi",
	"yiy": "yrm",
	"yma": "lrr",
	"ymt": "mtm",
	"yor": "yo",
	"yos": "zom",
	"yuu": "yug",
	"zai": "zap",
	"zh-cmn": "zh",
	"zh-cmn-Hans": "zh-Hans",
	"zh-cmn-Hant": "zh-Hant",
	"zh-gan": "gan",
	"zh-guoyu": "zh",
	"zh-hakka": "hak",
	"zh-min": "nan-x-zh-min",
	"zh-min-nan": "nan",
	"zh-wuu": "wuu",
	"zh-xiang": "hsn",
	"zh-yue": "yue",
	"zha": "za",
	"zho": "zh",
	"zir": "scv",
	"zkb": "kjh",
	"zsm": "ms",
	"zul": "zu",
	"zyb": "za"
};
export const territoryAlias = {
	"004": "AF",
	"008": "AL",
	"010": "AQ",
	"012": "DZ",
	"016": "AS",
	"020": "AD",
	"024": "AO",
	"028": "AG",
	"031": "AZ",
	"032": "AR",
	"036": "AU",
	"040": "AT",
	"044": "BS",
	"048": "BH",
	"050": "BD",
	"051": "AM",
	"052": "BB",
	"056": "BE",
	"060": "BM",
	"062": "034 143",
	"064": "BT",
	"068": "BO",
	"070": "BA",
	"072": "BW",
	"074": "BV",
	"076": "BR",
	"084": "BZ",
	"086": "IO",
	"090": "SB",
	"092": "VG",
	"096": "BN",
	"100": "BG",
	"104": "MM",
	"108": "BI",
	"112": "BY",
	"116": "KH",
	"120": "CM",
	"124": "CA",
	"132": "CV",
	"136": "KY",
	"140": "CF",
	"144": "LK",
	"148": "TD",
	"152": "CL",
	"156": "CN",
	"158": "TW",
	"162": "CX",
	"166": "CC",
	"170": "CO",
	"172": "RU AM AZ BY GE KG KZ MD TJ TM UA UZ",
	"174": "KM",
	"175": "YT",
	"178": "CG",
	"180": "CD",
	"184": "CK",
	"188": "CR",
	"191": "HR",
	"192": "CU",
	"196": "CY",
	"200": "CZ SK",
	"203": "CZ",
	"204": "BJ",
	"208": "DK",
	"212": "DM",
	"214": "DO",
	"218": "EC",
	"222": "SV",
	"226": "GQ",
	"230": "ET",
	"231": "ET",
	"232": "ER",
	"233": "EE",
	"234": "FO",
	"238": "FK",
	"239": "GS",
	"242": "FJ",
	"246": "FI",
	"248": "AX",
	"249": "FR",
	"250": "FR",
	"254": "GF",
	"258": "PF",
	"260": "TF",
	"262": "DJ",
	"266": "GA",
	"268": "GE",
	"270": "GM",
	"275": "PS",
	"276": "DE",
	"278": "DE",
	"280": "DE",
	"288": "GH",
	"292": "GI",
	"296": "KI",
	"300": "GR",
	"304": "GL",
	"308": "GD",
	"312": "GP",
	"316": "GU",
	"320": "GT",
	"324": "GN",
	"328": "GY",
	"332": "HT",
	"334": "HM",
	"336": "VA",
	"340": "HN",
	"344": "HK",
	"348": "HU",
	"352": "IS",
	"356": "IN",
	"360": "ID",
	"364": "IR",
	"368": "IQ",
	"372": "IE",
	"376": "IL",
	"380": "IT",
	"384": "CI",
	"388": "JM",
	"392": "JP",
	"398": "KZ",
	"400": "JO",
	"404": "KE",
	"408": "KP",
	"410": "KR",
	"414": "KW",
	"417": "KG",
	"418": "LA",
	"422": "LB",
	"426": "LS",
	"428": "LV",
	"430": "LR",
	"434": "LY",
	"438": "LI",
	"440": "LT",
	"442": "LU",
	"446": "MO",
	"450": "MG",
	"454": "MW",
	"458": "MY",
	"462": "MV",
	"466": "ML",
	"470": "MT",
	"474": "MQ",
	"478": "MR",
	"480": "MU",
	"484": "MX",
	"492": "MC",
	"496": "MN",
	"498": "MD",
	"499": "ME",
	"500": "MS",
	"504": "MA",
	"508": "MZ",
	"512": "OM",
	"516": "NA",
	"520": "NR",
	"524": "NP",
	"528": "NL",
	"530": "CW SX BQ",
	"531": "CW",
	"532": "CW SX BQ",
	"533": "AW",
	"534": "SX",
	"535": "BQ",
	"536": "SA IQ",
	"540": "NC",
	"548": "VU",
	"554": "NZ",
	"558": "NI",
	"562": "NE",
	"566": "NG",
	"570": "NU",
	"574": "NF",
	"578": "NO",
	"580": "MP",
	"581": "UM",
	"582": "FM MH MP PW",
	"583": "FM",
	"584": "MH",
	"585": "PW",
	"586": "PK",
	"591": "PA",
	"598": "PG",
	"600": "PY",
	"604": "PE",
	"608": "PH",
	"612": "PN",
	"616": "PL",
	"620": "PT",
	"624": "GW",
	"626": "TL",
	"630": "PR",
	"634": "QA",
	"638": "RE",
	"642": "RO",
	"643": "RU",
	"646": "RW",
	"652": "BL",
	"654": "SH",
	"659": "KN",
	"660": "AI",
	"662": "LC",
	"663": "MF",
	"666": "PM",
	"670": "VC",
	"674": "SM",
	"678": "ST",
	"682": "SA",
	"686": "SN",
	"688": "RS",
	"690": "SC",
	"694": "SL",
	"702": "SG",
	"703": "SK",
	"704": "VN",
	"705": "SI",
	"706": "SO",
	"710": "ZA",
	"716": "ZW",
	"720": "YE",
	"724": "ES",
	"728": "SS",
	"729": "SD",
	"732": "EH",
	"736": "SD",
	"740": "SR",
	"744": "SJ",
	"748": "SZ",
	"752": "SE",
	"756": "CH",
	"760": "SY",
	"762": "TJ",
	"764": "TH",
	"768": "TG",
	"772": "TK",
	"776": "TO",
	"780": "TT",
	"784": "AE",
	"788": "TN",
	"792": "TR",
	"795": "TM",
	"796": "TC",
	"798": "TV",
	"800": "UG",
	"804": "UA",
	"807": "MK",
	"810": "RU AM AZ BY EE GE KZ KG LV LT MD TJ TM UA UZ",
	"818": "EG",
	"826": "GB",
	"830": "JE GG",
	"831": "GG",
	"832": "JE",
	"833": "IM",
	"834": "TZ",
	"840": "US",
	"850": "VI",
	"854": "BF",
	"858": "UY",
	"860": "UZ",
	"862": "VE",
	"876": "WF",
	"882": "WS",
	"886": "YE",
	"887": "YE",
	"890": "RS ME SI HR MK BA",
	"891": "RS ME",
	"894": "ZM",
	"958": "AA",
	"959": "QM",
	"960": "QN",
	"962": "QP",
	"963": "QQ",
	"964": "QR",
	"965": "QS",
	"966": "QT",
	"967": "EU",
	"968": "QV",
	"969": "QW",
	"970": "QX",
	"971": "QY",
	"972": "QZ",
	"973": "XA",
	"974": "XB",
	"975": "XC",
	"976": "XD",
	"977": "XE",
	"978": "XF",
	"979": "XG",
	"980": "XH",
	"981": "XI",
	"982": "XJ",
	"983": "XK",
	"984": "XL",
	"985": "XM",
	"986": "XN",
	"987": "XO",
	"988": "XP",
	"989": "XQ",
	"990": "XR",
	"991": "XS",
	"992": "XT",
	"993": "XU",
	"994": "XV",
	"995": "XW",
	"996": "XX",
	"997": "XY",
	"998": "XZ",
	"999": "ZZ",
	"AAA": "AA",
	"ABW": "AW",
	"AFG": "AF",
	"AGO": "AO",
	"AIA": "AI",
	"ALA": "AX",
	"ALB": "AL",
	"AN": "CW SX BQ",
	"AND": "AD",
	"ANT": "CW SX BQ",
	"ARE": "AE",
	"ARG": "AR",
	"ARM": "AM",
	"ASC": "AC",
	"ASM": "AS",
	"ATA": "AQ",
	"ATF": "TF",
	"ATG": "AG",
	"AUS": "AU",
	"AUT": "AT",
	"AZE": "AZ",
	"BDI": "BI",
	"BEL": "BE",
	"BEN": "BJ",
	"BES": "BQ",
	"BFA": "BF",
	"BGD": "BD",
	"BGR": "BG",
	"BHR": "BH",
	"BHS": "BS",
	"BIH": "BA",
	"BLM": "BL",
	"BLR": "BY",
	"BLZ": "BZ",
	"BMU": "BM",
	"BOL": "BO",
	"BRA": "BR",
	"BRB": "BB",
	"BRN": "BN",
	"BTN": "BT",
	"BU": "MM",
	"BUR": "MM",
	"BVT": "BV",
	"BWA": "BW",
	"CAF": "CF",
	"CAN": "CA",
	"CCK": "CC",
	"CHE": "CH",
	"CHL": "CL",
	"CHN": "CN",
	"CIV": "CI",
	"CMR": "CM",
	"COD": "CD",
	"COG": "CG",
	"COK": "CK",
	"COL": "CO",
	"COM": "KM",
	"CPT": "CP",
	"CPV": "CV",
	"CRI": "CR",
	"CS": "RS ME",
	"CT": "KI",
	"CUB": "CU",
	"CUW": "CW",
	"CXR": "CX",
	"CYM": "KY",
	"CYP": "CY",
	"CZE": "CZ",
	"DD": "DE",
	"DDR": "DE",
	"DEU": "DE",
	"DGA": "DG",
	"DJI": "DJ",
	"DMA": "DM",
	"DNK": "DK",
	"DOM": "DO",
	"DY": "BJ",
	"DZA": "DZ",
	"ECU": "EC",
	"EGY": "EG",
	"ERI": "ER",
	"ESH": "EH",
	"ESP": "ES",
	"EST": "EE",
	"ETH": "ET",
	"FIN": "FI",
	"FJI": "FJ",
	"FLK": "FK",
	"FQ": "AQ TF",
	"FRA": "FR",
	"FRO": "FO",
	"FSM": "FM",
	"FX": "FR",
	"FXX": "FR",
	"GAB": "GA",
	"GBR": "GB",
	"GEO": "GE",
	"GGY": "GG",
	"GHA": "GH",
	"GIB": "GI",
	"GIN": "GN",
	"GLP": "GP",
	"GMB": "GM",
	"GNB": "GW",
	"GNQ": "GQ",
	"GRC": "GR",
	"GRD": "GD",
	"GRL": "GL",
	"GTM": "GT",
	"GUF": "GF",
	"GUM": "GU",
	"GUY": "GY",
	"HKG": "HK",
	"HMD": "HM",
	"HND": "HN",
	"HRV": "HR",
	"HTI": "HT",
	"HUN": "HU",
	"HV": "BF",
	"IDN": "ID",
	"IMN": "IM",
	"IND": "IN",
	"IOT": "IO",
	"IRL": "IE",
	"IRN": "IR",
	"IRQ": "IQ",
	"ISL": "IS",
	"ISR": "IL",
	"ITA": "IT",
	"JAM": "JM",
	"JEY": "JE",
	"JOR": "JO",
	"JPN": "JP",
	"JT": "UM",
	"KAZ": "KZ",
	"KEN": "KE",
	"KGZ": "KG",
	"KHM": "KH",
	"KIR": "KI",
	"KNA": "KN",
	"KOR": "KR",
	"KWT": "KW",
	"LAO": "LA",
	"LBN": "LB",
	"LBR": "LR",
	"LBY": "LY",
	"LCA": "LC",
	"LIE": "LI",
	"LKA": "LK",
	"LSO": "LS",
	"LTU": "LT",
	"LUX": "LU",
	"LVA": "LV",
	"MAC": "MO",
	"MAF": "MF",
	"MAR": "MA",
	"MCO": "MC",
	"MDA": "MD",
	"MDG": "MG",
	"MDV": "MV",
	"MEX": "MX",
	"MHL": "MH",
	"MI": "UM",
	"MKD": "MK",
	"MLI": "ML",
	"MLT": "MT",
	"MMR": "MM",
	"MNE": "ME",
	"MNG": "MN",
	"MNP": "MP",
	"MOZ": "MZ",
	"MRT": "MR",
	"MSR": "MS",
	"MTQ": "MQ",
	"MUS": "MU",
	"MWI": "MW",
	"MYS": "MY",
	"MYT": "YT",
	"NAM": "NA",
	"NCL": "NC",
	"NER": "NE",
	"NFK": "NF",
	"NGA": "NG",
	"NH": "VU",
	"NIC": "NI",
	"NIU": "NU",
	"NLD": "NL",
	"NOR": "NO",
	"NPL": "NP",
	"NQ": "AQ",
	"NRU": "NR",
	"NT": "SA IQ",
	"NTZ": "SA IQ",
	"NZL": "NZ",
	"OMN": "OM",
	"PAK": "PK",
	"PAN": "PA",
	"PC": "FM MH MP PW",
	"PCN": "PN",
	"PER": "PE",
	"PHL": "PH",
	"PLW": "PW",
	"PNG": "PG",
	"POL": "PL",
	"PRI": "PR",
	"PRK": "KP",
	"PRT": "PT",
	"PRY": "PY",
	"PSE": "PS",
	"PU": "UM",
	"PYF": "PF",
	"PZ": "PA",
	"QAT": "QA",
	"QMM": "QM",
	"QNN": "QN",
	"QPP": "QP",
	"QQQ": "QQ",
	"QRR": "QR",
	"QSS": "QS",
	"QTT": "QT",
	"QU": "EU",
	"QUU": "EU",
	"QVV": "QV",
	"QWW": "QW",
	"QXX": "QX",
	"QYY": "QY",
	"QZZ": "QZ",
	"REU": "RE",
	"RH": "ZW",
	"ROU": "RO",
	"RUS": "RU",
	"RWA": "RW",
	"SAU": "SA",
	"SCG": "RS ME",
	"SDN": "SD",
	"SEN": "SN",
	"SGP": "SG",
	"SGS": "GS",
	"SHN": "SH",
	"SJM": "SJ",
	"SLB": "SB",
	"SLE": "SL",
	"SLV": "SV",
	"SMR": "SM",
	"SOM": "SO",
	"SPM": "PM",
	"SRB": "RS",
	"SSD": "SS",
	"STP": "ST",
	"SU": "RU AM AZ BY EE GE KZ KG LV LT MD TJ TM UA UZ",
	"SUN": "RU AM AZ BY EE GE KZ KG LV LT MD TJ TM UA UZ",
	"SUR": "SR",
	"SVK": "SK",
	"SVN": "SI",
	"SWE": "SE",
	"SWZ": "SZ",
	"SXM": "SX",
	"SYC": "SC",
	"SYR": "SY",
	"TAA": "TA",
	"TCA": "TC",
	"TCD": "TD",
	"TGO": "TG",
	"THA": "TH",
	"TJK": "TJ",
	"TKL": "TK",
	"TKM": "TM",
	"TLS": "TL",
	"TMP": "TL",
	"TON": "TO",
	"TP": "TL",
	"TTO": "TT",
	"TUN": "TN",
	"TUR": "TR",
	"TUV": "TV",
	"TWN": "TW",
	"TZA": "TZ",
	"UGA": "UG",
	"UK": "GB",
	"UKR": "UA",
	"UMI": "UM",
	"URY": "UY",
	"USA": "US",
	"UZB": "UZ",
	"VAT": "VA",
	"VCT": "VC",
	"VD": "VN",
	"VEN": "VE",
	"VGB": "VG",
	"VIR": "VI",
	"VNM": "VN",
	"VUT": "VU",
	"WK": "UM",
	"WLF": "WF",
	"WSM": "WS",
	"XAA": "XA",
	"XBB": "XB",
	"XCC": "XC",
	"XDD": "XD",
	"XEE": "XE",
	"XFF": "XF",
	"XGG": "XG",
	"XHH": "XH",
	"XII": "XI",
	"XJJ": "XJ",
	"XKK": "XK",
	"XLL": "XL",
	"XMM": "XM",
	"XNN": "XN",
	"XOO": "XO",
	"XPP": "XP",
	"XQQ": "XQ",
	"XRR": "XR",
	"XSS": "XS",
	"XTT": "XT",
	"XUU": "XU",
	"XVV": "XV",
	"XWW": "XW",
	"XXX": "XX",
	"XYY": "XY",
	"XZZ": "XZ",
	"YD": "YE",
	"YEM": "YE",
	"YMD": "YE",
	"YU": "RS ME",
	"YUG": "RS ME",
	"ZAF": "ZA",
	"ZAR": "CD",
	"ZMB": "ZM",
	"ZR": "CD",
	"ZWE": "ZW",
	"ZZZ": "ZZ"
};
export const scriptAlias = { "Qaai": "Zinh" };
export const variantAlias = {
	"heploc": "alalc97",
	"polytoni": "polyton"
};
